import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import { unrefElement, tryOnScopeDispose } from '~/utils/VueUseHelpers';
var isClient = typeof window !== 'undefined';
var defaultWindow = isClient ? window : undefined;
var isString = function isString(val) {
  return typeof val === 'string';
};
var noop = function noop() {};
function useEventListener() {
  var target;
  var events;
  var listeners;
  var options;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (isString(args[0]) || Array.isArray(args[0])) {
    events = args[0];
    listeners = args[1];
    options = args[2];
    target = defaultWindow;
  } else {
    target = args[0];
    events = args[1];
    listeners = args[2];
    options = args[3];
  }
  if (!target) return noop;
  if (!Array.isArray(events)) events = [events];
  if (!Array.isArray(listeners)) listeners = [listeners];
  var cleanups = [];
  var cleanup = function cleanup() {
    cleanups.forEach(function (fn) {
      return fn();
    });
    cleanups.length = 0;
  };
  var register = function register(el, event, listener) {
    el.addEventListener(event, listener, options);
    return function () {
      return el.removeEventListener(event, listener, options);
    };
  };
  var stopWatch = watch(function () {
    return unrefElement(target);
  }, function (el) {
    cleanup();
    if (!el) return;
    cleanups.push.apply(cleanups, _toConsumableArray(events.flatMap(function (event) {
      return listeners.map(function (listener) {
        return register(el, event, listener);
      });
    })));
  }, {
    immediate: true,
    flush: 'post'
  });
  var stop = function stop() {
    stopWatch();
    cleanup();
  };
  tryOnScopeDispose(stop);
  return stop;
}
function tryOnMounted(fn) {
  var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (getCurrentInstance()) onMounted(fn);else if (sync) fn();else nextTick(fn);
}
export function useWindowSize() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$window = options.window,
    window = _options$window === void 0 ? defaultWindow : _options$window,
    _options$initialWidth = options.initialWidth,
    initialWidth = _options$initialWidth === void 0 ? Infinity : _options$initialWidth,
    _options$initialHeigh = options.initialHeight,
    initialHeight = _options$initialHeigh === void 0 ? Infinity : _options$initialHeigh,
    _options$listenOrient = options.listenOrientation,
    listenOrientation = _options$listenOrient === void 0 ? true : _options$listenOrient,
    _options$includeScrol = options.includeScrollbar,
    includeScrollbar = _options$includeScrol === void 0 ? true : _options$includeScrol;
  var width = ref(initialWidth);
  var height = ref(initialHeight);
  var update = function update() {
    if (window) {
      if (includeScrollbar) {
        width.value = window.innerWidth;
        height.value = window.innerHeight;
      } else {
        width.value = window.document.documentElement.clientWidth;
        height.value = window.document.documentElement.clientHeight;
      }
    }
  };
  update();
  tryOnMounted(update);
  useEventListener('resize', update, {
    passive: true
  });
  if (listenOrientation) useEventListener('orientationchange', update, {
    passive: true
  });
  return {
    width: width,
    height: height
  };
}